import { render, staticRenderFns } from "./MultipleQuestion.vue?vue&type=template&id=767568a8&"
import script from "./MultipleQuestion.vue?vue&type=script&lang=ts&"
export * from "./MultipleQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports